<template>
  <div v-show="navigationHistory" :class="bemBlock">
    <button
      type="button"
      :class="[bemElement('btn'), 'btn', 'btn--back']"
      @click.stop="handleClickBackButton()"
    >
      {{ $msg('header.back', 'header') }}
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import bemClassesMixin from '../mixins/bemClassesMixin';
import store, { types } from '../store';

export default {
  name: 'BaseBackButton',

  mixins: [bemClassesMixin],

  computed: {
    ...mapState({
      navigationHistory: (state) => state.navigation.historyCount > 0,
    }),
  },

  /*
    Need to set up listener to change the classname when the content is scroll down or up
    To handle by styles the position of the back button. When is down and is in the middle of
    the viewport the position will be fixed, other wise will be sticky.
  */
  created() {
    const historyCount = window.sessionStorage.getItem(
      'navigationHistoryCount'
    );
    const sameOrigin = document.referrer.startsWith(window.location.origin);

    if (
      historyCount <= 1 ||
      (!sameOrigin &&
        !this.isReloadPage() &&
        !document.querySelector('.the-product-list'))
    ) {
      window.sessionStorage.setItem('navigationHistoryCount', 0);
      store.commit(types.navigation.setHistoryCount, 0);
    }
  },

  methods: {
    isReloadPage() {
      const entries = performance.getEntriesByType('navigation');
      return entries.map((nav) => nav.type)[0] === 'reload';
    },

    handleClickBackButton() {
      this.$store.commit(types.navigation.setIsBackButtonClicked, true);
      this.$router.back();
    },
  },
};
</script>
